import React from 'react';
import client from '../../utils/eventEmit';
import { Typography, Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const ErrorHandling = () => {
  const history = useHistory();
  const [errorMsg, setErrorMsg] = React.useState<any>('');
  const [open, isOpen] = React.useState<any>(false);
  const setError = (data: any) => {
    setErrorMsg(data[0]?.result?.error_description || '');
    isOpen(true);
  };
  client.on('networkError', setError);

  const handleOK = () => {
    history.push('/login');
  };

  return (
    <div>
      {errorMsg && (
        <Dialog open={open} aria-labelledby="customized-dialog-title">
          <DialogContent>
            <DialogContentText>
              <Typography>{errorMsg}</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" autoFocus variant="contained" onClick={handleOK}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default ErrorHandling;
